
import { AlertTriangle, X, RefreshCw } from 'lucide-react'
import { useState } from 'react'
import useSWR from 'swr'

const fetcher = (url: string) => fetch(url).then(r => r.json())

interface D1ConnectionBannerProps {
  workerUrl: string
}

export function D1ConnectionBanner({ workerUrl: _workerUrl }: D1ConnectionBannerProps) {
  const [dismissed, setDismissed] = useState(false)
  const { data: health, mutate } = useSWR('/api/health', fetcher, { refreshInterval: 30_000 })

  const d1Status = health?.d1?.status

  if (dismissed) return null
  if (!health) return null
  if (d1Status === 'ok') return null

  const message =
    d1Status === 'unauthorized'
      ? 'D1 worker returned 401. Verify the Worker is deployed and auth is configured.'
      : 'D1 worker is unreachable. Check that the Worker is deployed and active.'

  return (
    <div className="flex items-center gap-2.5 rounded-lg border border-warning/30 bg-warning/5 px-3.5 py-2.5 mb-5">
      <AlertTriangle className="w-4 h-4 text-warning flex-shrink-0" />
      <p className="flex-1 text-xs text-muted-foreground">
        <span className="font-medium text-warning mr-1.5">D1</span>
        {message}
      </p>
      <button
        onClick={() => mutate()}
        className="p-1 rounded text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Retry connection"
      >
        <RefreshCw className="w-3.5 h-3.5" />
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 rounded text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  )
}
